import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[filterReview]',
    standalone: false
})
export class FilterReviewDirective {
  constructor(el: ElementRef) {
    el.nativeElement.style.backgroundColor = 'yellow';
  }
}